import React from 'react'
import Header from './users/Header'
import Footer from './users/Footer'
import NavHeader from './users/NavHeader'

const Faq = () => {
  return (
    <div className="antialiased bg-primary md:block md:bg-gray-100" style={{ backgroundImage: `url('/images/bg-body.png')` }} relative>
        <NavHeader />
      <div className="max-w-[600px] mx-auto max-h-screen min-h-screen bg-white shadow-2xl">
        <Header />
        Faqq uuuuuuuuuu
      </div>
        <Footer />
    </div>
  )
}

export default Faq